export default __webpack_public_path__ + "static/media/captacha.74950258.svg";